export default __webpack_public_path__ + "static/media/kes.8592385a.svg";